import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Navbar from './components/Navbar';
import NotificationsBanner from './components/NotificationsBanner';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SolutionsPage from './pages/SolutionsPage';
import SolutionAutomatedTriagePage from './pages/SolutionAutomatedTriagePage';
import SolutionContextPage from './pages/SolutionContextPage';
import SolutionAgentsPage from './pages/SolutionAgentsPage';
import SolutionAssistedRemediationPage from './pages/SolutionAssistedRemediationPage';
import TrustCentre from './pages/TrustCentre';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import BlogSoc2CompliancePage from './pages/BlogSoc2CompliancePage';
import BlogSoc2Type2Page from './pages/BlogSoc2Type2Page';
import BlogCtemAssetInventoryPage from './pages/BlogCtemAssetInventoryPage';
import BlogFeatureTrapPage from './pages/BlogFeatureTrapPage';
import BlogNewTechOldCategoriesPage from './pages/BlogNewTechOldCategoriesPage';
import BlogIfItsNotShippedPage from './pages/BlogIfItsNotShippedPage';
import BlogSeverityRankingsPage from './pages/BlogSeverityRankingsPage';
import BlogAgenticBlastRadiusPage from './pages/BlogAgenticBlastRadiusPage';
import BlogOidcAwsAccessPage from './pages/BlogOidcAwsAccessPage';
import { useScrollToHash } from './hooks/useScrollToHash';
import './App.css';

function AppContent() {
  useScrollToHash();
  return (
    <>
      <Navbar />
      <NotificationsBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/solutions/context" element={<SolutionContextPage />} />
        <Route path="/solutions/agents" element={<SolutionAgentsPage />} />
        <Route path="/solutions/assisted-remediation" element={<SolutionAssistedRemediationPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/solutions/automated-triage" element={<SolutionAutomatedTriagePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/trust" element={<TrustCentre />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/i-helped-create-the-problem-im-now-solving" element={<BlogPostPage />} />
        <Route path="/blog/the-feature-trap-security-industry-outcomes" element={<BlogFeatureTrapPage />} />
        <Route path="/blog/soc-2-type-1-compliance" element={<BlogSoc2CompliancePage />} />
        <Route path="/blog/soc-2-type-2-attestation" element={<BlogSoc2Type2Page />} />
        <Route path="/blog/ctem-and-the-asset-inventory-problem" element={<BlogCtemAssetInventoryPage />} />
        <Route
          path="/blog/stop-trying-to-fit-new-technology-into-old-categories"
          element={<BlogNewTechOldCategoriesPage />}
        />
        <Route path="/blog/if-its-not-shipped-its-not-fixed" element={<BlogIfItsNotShippedPage />} />
        <Route
          path="/blog/severity-rankings-dont-shrink-risk"
          element={<BlogSeverityRankingsPage />}
        />
        <Route
          path="/blog/containing-the-agentic-blast-radius"
          element={<BlogAgenticBlastRadiusPage />}
        />
        <Route
          path="/blog/multi-tenant-oidc-for-aws-access"
          element={<BlogOidcAwsAccessPage />}
        />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    // Determine the environment based on hostname
    // TODO: This is a temporary solution to get the environment based on the hostname. 
    // We should use load this from an environment variable.
    const hostname = window.location.hostname;
    let environment;
    let GA4_ID;

    switch (hostname) {
      case 'circumvent.io':
        environment = 'production';
        GA4_ID = 'G-8FME90Q0B8';
        break;
      case 'gateway.circumvent-staging.com':
        environment = 'staging';
        GA4_ID = 'G-X6E7ZK7K6B';
        break;
      default:
        environment = 'development';
        GA4_ID = 'G-Z7H20M41C0';
    }
    
    // Initialize GA with environment-specific configuration
    ReactGA.initialize(GA4_ID, {
      gaOptions: {
        debug_mode: environment !== 'production'
      }
    });

    // Send pageview with environment information
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      environment
    });

    // Set a custom dimension for environment
    ReactGA.set({ environment });
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <AppContent />
      </div>
    </BrowserRouter>
  );
}

export default App; 